/*
 * Copyright (c) 2021-2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: label.paths.ts
 * Project: mle-client
 * Committed last: 2021/10/14 @ 1517
 * ---
 */

export enum LabelPaths {
  ROOT = '/label',
  BY_ID = '/label/:labelId',
  NOT_FOUND = '/label-not-found',
}
